import { Dispatch } from 'redux';
import store from '~/data/store';
import { createRequest } from '~/data/store/reducer/appointment/actions/create';

import { iActionCreate } from '~/domain/interfaces/redux/appointment/create';

import { CreateAppointment } from '~/domain/usecases/appointment/redux';

export class ReduxCreateAppointment implements CreateAppointment {
  private send: Dispatch;

  constructor() {
    this.send = store.dispatch;
  }

  create = (params: CreateAppointment.Params): iActionCreate =>
    this.send(createRequest(params));
}
